/*
 * @Author: Zhouqi
 * @Date: 2025-12-01 17:40:29
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-23 11:10:06
 */
import React from 'react';

import { UseTranslateType } from '@/hooks/useTranslate';
import UserStore from '@/store/User';
import { fc_purchase_alert_expose } from '@/utils/eventlog/eventNewConfig';

import { AICreditModal, ExchangeCodeModal } from '../../..';
import { TabContentProps } from '..';
import DoubleArrowIcon from '../icon/doubleArrow';

interface footerProps {
  t: UseTranslateType | undefined;
  activeTab: TabContentProps['activeKey'];
  feature: fc_purchase_alert_expose['from'];

  destroyRef: any;
}

const Footer: React.FC<footerProps> = ({ t, activeTab, feature, destroyRef }) => {
  if (!t) {
    return;
  }

  return (
    <div className="flex flex-col items-center gap-[8px] py-[14px]">
      <div className="flex justify-center items-center select-none">
        <span
          className="text-payment-modal-card-link-color hover:text-payment-modal-card-link-hover-color transition-colors text-[16px] font-[500] cursor-pointer"
          onClick={() => {
            ExchangeCodeModal.show({
              from: 'sub_pop_coupon',
              onClose: () => {
                // 弹窗关闭后，自动刷新用户的优惠券
                UserStore.getState().getCouponInfo();
              },
            });
          }}
        >
          {t('merror.code.meredeem')}
        </span>
        <span className="inline-block w-[1px] h-[10px] bg-[#000] opacity-40 mx-[12px]"></span>
        {UserStore.getState().currentVip.weight !== 1 ? (
          <>
            <span
              className="text-payment-modal-card-link-color hover:text-payment-modal-card-link-hover-color transition-colors text-[16px] font-[500] cursor-pointer"
              onClick={() => {
                destroyRef?.current?.();
                AICreditModal.show({ feature, showBanner: false });
              }}
            >
              {t('Buy-More-AICredits')}
            </span>
            <span className="inline-block w-[1px] h-[10px] bg-[#000] opacity-40 mx-[12px]"></span>
          </>
        ) : null}
        <span
          className="text-payment-modal-card-link-color hover:text-payment-modal-card-link-hover-color transition-colors text-[16px] font-[500] cursor-pointer"
          onClick={() => {
            window.open('https://falcocut.com/pricing');
          }}
        >
          {t && t('bc.compare')}
        </span>
        <DoubleArrowIcon />
      </div>
    </div>
  );
};

export default Footer;
